export default {
  singleLabel: "Organisme d'étalonnage",
  fields: [{
      name: 'company_name',
      label: "Nom",
      type: 'text',
      inPdfExport: true,
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/ProductCompany/config.js